import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assignKpiToSubprojects } from '@/features/projects/project-details/api/assign-kpi-to-subprojects';
import { getProjectSubprojectsQueryKey } from '@/features/projects/shared/hooks/use-project-subprojects';

export const useAssignKpiToSubprojects = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: assignKpiToSubprojects,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getProjectSubprojectsQueryKey({ projectId }),
      });
    },
  });
};
